import { getToken } from "@vue/services/jwt.service";
import * as Sentry from "@sentry/browser";

getToken(); // HACK: getToken has side effects (updates sentry tags).

export const trackError = error => {
  Sentry.captureException(error);
};
